// The web app's runtime-config schema — one key per `NEXT_PUBLIC_*` it reads
// today (grep of apps/web/src), stripped of the prefix. This schema is the
// allow-list both `loadEnv` (the browser-side reader) and
// scripts/generate-env-js.mjs (the container-start generator) consume, so the
// two can never drift out of sync.
import { loadEnv } from "../load-env.js";
import { defineEnvSchema, optional, required } from "../schema.js";
import { absoluteUrl } from "../validators.js";
const BRANDS = ["ARGUMED", "PIMA", "DEAREST", "ZAP"];
const brandKeys = BRANDS.flatMap((brand) => [
    optional(`${brand}_PUBLIC_NAME`),
    optional(`${brand}_PROJECT_URL`),
    optional(`${brand}_PUBLIC_COLOR`),
    optional(`${brand}_PUBLIC_LOGO_ID`),
    optional(`${brand}_FROM_EMAIL`),
    optional(`COCKPIT_${brand}`),
    optional(`HELPCENTER_${brand}`),
]);
export const webEnvSchema = defineEnvSchema([
    // Absolute API host — SSO redirect target and the Personio webhook URL
    // shown to users. Never the same-origin `/api` proxy path (see
    // ../validators.ts for why).
    required("PUBLIC_API_URL", absoluteUrl),
    required("APP_URL", absoluteUrl),
    required("OHS_ADMIN_ROLE_ID"),
    required("OHS_OFFICER_ROLE_ID"),
    required("LOCATION_MANAGER_ROLE_ID"),
    required("SIFA_ROLE_ID"),
    required("AMA_ROLE_ID"),
    required("EMPLOYEE_ROLE_ID"),
    required("EXTERNAL_SIFA_ROLE_ID"),
    required("PROTECTED_FOLDER_ID"),
    required("PUBLIC_FOLDER_ID"),
    // The chart supplies this at container start. Local development may omit it;
    // that disables the login-time stale-build check.
    optional("APP_VERSION"),
    optional("WISSEN_DEAREST"),
    // Whether these become required is a P5 (Sentry migration) decision; keep
    // them optional until that's settled so a Sentry-disabled env still boots.
    optional("SENTRY_DSN"),
    optional("SENTRY_ENVIRONMENT"),
    optional("SENTRY_RELEASE"),
    // PMO-62 unified-access migration switch; on only for the exact string
    // `true` (see apps/web/src/lib/unified-access.ts).
    optional("UNIFIED_ACCESS_ENABLED"),
    // PMO-835: whether inspectors get the + that records a Mangel on a running
    // inspection; on only for the exact string `true` (see
    // apps/web/src/lib/inspections/add-risk/enabled.ts).
    optional("ADD_INSPECTION_RISK_ENABLED"),
    ...brandKeys,
]);
/** Validates and returns the web app's runtime config from `window.__ENV__`. */
export function loadWebEnv(source) {
    return loadEnv(webEnvSchema, source);
}
//# sourceMappingURL=web.js.map